import { Grid } from "@mui/material";

export default () => (
    <Grid
        container
        justifyContent="center">
        <img src="/CB-logo.png" alt="logo" />
    </Grid>
);